import { OrderRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class OrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new OrderRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	getUnlinkedOrderLines(filter) {
		var url = this.routeService.getUnlinkedOrderLines(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	createOrdersBulk(orders, sourceOfChange) {
		var url = this.routeService.createOrdersBulk(orders, sourceOfChange);
		return this.apiClient.post(url, orders);
	}

	replace(replaceParams, sourceOfChange) {
		const url = this.routeService.replace(replaceParams, sourceOfChange);
		return this.apiClient.post(url, replaceParams);
	}

	validateOrderAddress(order) {
		var url = this.routeService.validateOrderAddress(order);
		return this.apiClient.put(url, order);
	}

	getDistinctValues(distinctSearchParams) {
		var url = this.routeService.getDistinctValues();
		return this.apiClient.post(url, distinctSearchParams);
	}

	updateOrderInfo(order, sourceOfChange) {
		var url = this.routeService.updateOrderInfo(order, sourceOfChange);
		return this.apiClient.put(url, order);
	}
}

export default OrderService;



// WEBPACK FOOTER //
// ./src/common/data/services/OrderService.js